function required(name: keyof ImportMetaEnv): string {
  const v = import.meta.env[name];
  if (typeof v !== 'string' || v === '') {
    throw new Error(`missing env: ${name}`);
  }
  return v;
}

export const env = {
  apiOrigin: required('VITE_API_ORIGIN'),
  posthogKey: import.meta.env.VITE_POSTHOG_KEY,
  posthogHost: import.meta.env.VITE_POSTHOG_HOST,
  // Visible build marker rendered in the footer; the deploy smoke test
  // greps the same SHA out of the static <meta name="build-sha"> in
  // index.html (which Vite substitutes at build time).
  buildSha: import.meta.env.VITE_BUILD_SHA ?? 'dev',
  // Operator-provided PayPal client id. Optional: empty/undefined => the
  // checkout page shows a "payment unavailable" notice instead of the button.
  paypalClientId: import.meta.env.VITE_PAYPAL_CLIENT_ID ?? '',
};
